
const EnumtestActions = Object.freeze({
    UPDATE_TESTO: "UPDATE_TESTO",
    CHECK_BOX: "CHECK_BOX",
    CHANGE_SELECT: "CHANGE_SELECT",
    SHOW_POPOUP_DELETE: 'SHOW_POPOUP_DELETE',
    SHOW_POPOUP_SAVE: 'SHOW_POPOUP_SAVE',
});

module.exports.EnumtestActions = EnumtestActions;



class TestActions {
    constructor() {
        this.moduleName = "[testActions.js]";
    }

    get Actions() {
        return EnumtestActions;
    }

    checkBox(checkBox) {
        console.log(this.moduleName + " checkBox")
        return function (dispatch) {
            dispatch({ type: EnumtestActions.CHECK_BOX, check: checkBox })
        }
    }

    updateTesto(textField) {
        console.log(this.moduleName + " updateTesto")
        return function (dispatch) {
            dispatch({ type: EnumtestActions.UPDATE_TESTO, valueTextField: textField });
        }
    }

    changeSelect(newSelect) {
        console.log(this.moduleName + " ChangeSelect")
        return function (dispatch) {
            dispatch({ type: EnumtestActions.CHANGE_SELECT, newSelectValue: newSelect });
        }
    }

    showPopUPDelete(isShow) {
        console.log(this.moduleName + " showPopUpDelete [isShow] " + isShow);
        return function (dispatch) {
            let updateVisModal = { showModalDelete: { $set: isShow } }
            dispatch({ type: EnumtestActions.SHOW_POPOUP_DELETE, showPopUpDelete: updateVisModal });
        }
    }

    showPopUPSave(isShow) {
        console.log(this.moduleNam + "  showPopUPSave [isShow] " + isShow);
        return function (dispatch) {
            let updateVisModal = { showModalSave: { $set: isShow } }
            dispatch({ type: EnumtestActions.SHOW_POPOUP_SAVE, showPopUpSave: updateVisModal });
        }
    }

}
export default TestActions = new TestActions;